import ComboBox from "../../components/ComboBox";
import Container from "../../components/Container";
import CustomInput from "../../components/CustomInput";
import CheckoutSummary from "./CheckoutSummary";
import countryListArray from "../../assets/data/countryList.json";

const Checkout = () => {
  const states = [
    {
      id: 0,
      value: "sanaa",
      label: "Sana'a",
    },
    {
      id: 1,
      value: "aden",
      label: "Aden",
    },
    {
      id: 2,
      value: "taiz",
      label: "Taiz",
    },
  ];
  const countryList = countryListArray.map((country, index) => ({
    id: index,
    value: country.toLowerCase(),
    label: country,
  }));

  return (
    <section className="bg-white">
      <Container>
        <div className="flex flex-wrap">
          <div className="shipping-address xs:w-full lg:w-1/2">
            <div className="title text-lg font-medium px-4">
              <h2>Shipping Address</h2>
            </div>
            <div className="form pt-4 text-sm text-[#8b8b8b]">
              <form action="">
                <div className="flex flex-wrap">
                  <CustomInput
                    label={"First Name"}
                    name="first-name"
                    placeholder={"Enter your first name"}
                    className="xs:w-full lg:w-1/2 px-4 mb-4"
                  />
                  <CustomInput
                    label={"Last Name"}
                    name="last-name"
                    placeholder={"Enter your last name"}
                    className="xs:w-full lg:w-1/2 px-4 mb-4"
                  />
                  <CustomInput
                    label={"Email (optional)"}
                    name="email"
                    placeholder={"Enter your email"}
                    type="email"
                    className="xs:w-full px-4 mb-4"
                  />
                  <CustomInput
                    label={"Address"}
                    name="address-1"
                    placeholder={"Enter your address"}
                    type="text"
                    className="xs:w-full px-4 mb-4"
                  />
                  <CustomInput
                    label={"Address 2 (optional)"}
                    name="address-2"
                    placeholder={"Enter your address 2"}
                    type="text"
                    className="xs:w-full px-4 mb-4"
                  />
                  <div className="xs:w-full md:w-5/12 px-4 mb-4 flex flex-col">
                    <label htmlFor="country" className="pb-1">
                      Country
                    </label>
                    <ComboBox
                      options={countryList}
                      selectedClassNames={{
                        border: "border-2",
                        rounded: "rounded-md",
                      }}
                      dropDownClassNames={{
                        minWidth: "min-w-full",
                      }}
                      isSearchable
                    />
                  </div>
                  <div className="xs:w-full md:w-4/12 px-4 mb-4 flex flex-col shrink-0">
                    <label htmlFor="country" className="pb-1">
                      States
                    </label>
                    <ComboBox
                      options={states}
                      selectedClassNames={{
                        border: "border-2",
                        rounded: "rounded-md",
                        padding: "p-4",
                      }}
                      dropDownClassNames={{
                        minWidth: "min-w-full",
                      }}
                    />
                  </div>
                  <CustomInput
                    label={"Zip Code"}
                    name="zip-code"
                    placeholder={"Enter Zip code"}
                    type="number"
                    className="xs:w-full md:w-3/12 px-4 mb-4 flex flex-col"
                  />
                </div>
              </form>
            </div>
          </div>
          <div className="summary xs:w-full lg:w-1/2">
            <CheckoutSummary />
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Checkout;
